import React from 'react';
import AttachmentIcon from "../../../../assets/attachment.svg";
import ArrowUpIcon from "../../../../assets/arrow-up.svg";
import TopicsDropdown from './TopicsDropdown';
import AutosaveIndicator from './AutosaveIndicator';
import { TopicCategory, Topic } from "../../../../services/NotesService";

interface SelectedTopic {
  id: number;
  name: string;
}

type AutosaveStatus = 'idle' | 'autosaving' | 'saved' | 'Error';

interface NoteModalFooterProps {
  // Attachment props
  uploadedAttachments: Array<{ id: number; fileName: string; size?: number; }>;
  onOpenFileBrowser: () => void;
  
  // Topics props
  topics: TopicCategory[];
  topicsStatus: string;
  selectedItems: SelectedTopic[];
  isDropdownOpen: boolean;
  onToggleDropdown: () => void;
  onCheckboxChange: (topic: Topic) => void;
  
  // Autosave props
  autosaveStatus: AutosaveStatus;
  
  // Save props
  onSave: () => void;
  saveNoteStatus: string;
  uploadStatus: string;
}

const NoteModalFooter: React.FC<NoteModalFooterProps> = ({
  uploadedAttachments,
  onOpenFileBrowser,
  topics,
  topicsStatus,
  selectedItems,
  isDropdownOpen,
  onToggleDropdown,
  onCheckboxChange,
  autosaveStatus,
  onSave,
  saveNoteStatus,
  uploadStatus
}) => {
  return (
    <div className="sticky bottom-0 p-6  border-t border-gray-200 bg-white z-20">
      <div className="flex justify-between items-center">
        {/* Left side - Attachment icon and topic dropdown */}
        <div className="flex items-center gap-3">
          <button
            onClick={onOpenFileBrowser}
            className="p-2 hover:bg-gray-100 rounded-md transition-colors"
            aria-label="Attach files"
            disabled={uploadedAttachments.length >= 10}
          >
            <img src={AttachmentIcon} alt="Attachment" className="w-5 h-5" />
          </button>

          {/* Topic Selection Dropdown */}
          <TopicsDropdown
            topics={topics}
            topicsStatus={topicsStatus}
            selectedItems={selectedItems}
            isDropdownOpen={isDropdownOpen}
            onToggleDropdown={onToggleDropdown}
            onCheckboxChange={onCheckboxChange}
          />
        </div>

        {/* Right side - Action buttons */}
        <div className="flex gap-3 items-center">
          <AutosaveIndicator status={autosaveStatus} />
          
          <button
            onClick={onSave}
            aria-label="Save Note"
            title="Save Note"
            disabled={saveNoteStatus === 'loading' || uploadStatus === 'loading'}
            className="flex items-center justify-center w-9 h-9 rounded-[18px] border border-[#E5E5E5] bg-white hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <img src={ArrowUpIcon} alt="Save" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoteModalFooter;
